import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../trans'

const tKey = TKey('components.feedback-modal-confirmation')

export const FeedbackModalConfirmation: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Typo>
        <WriskTrans t={t} i18nKey={tKey('text')} />
      </Typo>
    </Box>
  )
}
